import { ComponentProps } from 'react';
import { FormattedMessage as T, useIntl } from 'react-intl';
import { Field, Input, Label } from './FormElements';
import m from './messages';

type BaseInputProps = {
  label?: string;
} & Omit<ComponentProps<typeof Input>, 'type'>;

export const FirstNameField = ({
  className,
  label,
  ...rest
}: BaseInputProps) => {
  const intl = useIntl();

  return (
    <Field className={className}>
      <Label className="block w-full text-left">
        {label || <T {...m.firstNameLabel} />}
      </Label>
      <Input
        placeholder={intl.formatMessage(m.firstNamePlaceholder)}
        required
        name="first_name"
        type="text"
        {...rest}
      />
    </Field>
  );
};

export const LastNameField = ({
  className,
  label,
  ...rest
}: BaseInputProps) => {
  const intl = useIntl();

  return (
    <Field className={className}>
      <Label className="block w-full text-left">
        {label || <T {...m.lastNameLabel} />}
      </Label>
      <Input
        placeholder={intl.formatMessage(m.lastNamePlaceholder)}
        required
        name="last_name"
        type="text"
        {...rest}
      />
    </Field>
  );
};

export const EmailField = ({ className, label, ...rest }: BaseInputProps) => {
  const intl = useIntl();
  return (
    <Field className={className}>
      <Label className="block w-full text-left">
        {label || <T {...m.emailLabel} />}
      </Label>
      <Input
        placeholder={intl.formatMessage(m.emailPlaceholder)}
        name="email"
        type="email"
        required
        autoComplete="email"
        {...rest}
      />
    </Field>
  );
};
